import { useEffect, useState } from "react";
import { Phone, MessageCircle, CalendarCheck, ArrowUp } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data";

export const MobileBar = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <nav
        data-testid="mobile-sticky-action-bar"
        aria-label="Quick actions"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-gold/30 bg-navy/95 backdrop-blur-md md:hidden"
      >
        <a
          href={PHONE_TEL}
          data-testid="sticky-action-call"
          className="flex items-center justify-center gap-2 py-3.5 text-xs font-semibold uppercase tracking-wider text-cream transition-colors hover:text-gold"
        >
          <Phone className="h-4 w-4 text-gold" /> Call
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-action-whatsapp"
          className="flex items-center justify-center gap-2 border-x border-cream/10 py-3.5 text-xs font-semibold uppercase tracking-wider text-cream transition-colors hover:text-gold"
        >
          <MessageCircle className="h-4 w-4 text-gold" /> WhatsApp
        </a>
        <a
          href="#contact"
          data-testid="sticky-action-book"
          className="flex items-center justify-center gap-2 bg-gold py-3.5 text-xs font-semibold uppercase tracking-wider text-navy transition-colors hover:bg-gold-hover hover:text-cream"
        >
          <CalendarCheck className="h-4 w-4" /> Book Now
        </a>
      </nav>

      {showTop && (
        <button
          type="button"
          data-testid="back-to-top-button"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-20 right-4 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full bg-gold text-navy shadow-lg transition-colors hover:bg-gold-hover hover:text-cream md:bottom-6 md:right-6"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      )}
    </>
  );
};
